<template>
  <div>
    <div class="preview-title">
      <div>广告预览</div>
      <div class="preview-msg">{{ previewMsg[activeIndex - 1] }}</div>
      <div>
        <gj-button size="mini" icon="el-icon-arrow-left" @click="carouselOpt('prev')"></gj-button>
        <gj-button size="mini" icon="el-icon-arrow-right" @click="carouselOpt('next')"></gj-button>
      </div>
      <div class="tag">{{ activeIndex }} / 4</div>
    </div>
    <el-carousel ref="carousel" trigger="click" height="506px" width="538px" :autoplay="false" @change="change">
      <el-carousel-item>
        <div class="preview preview1">
          <div class="preview-content">
            <img class="preview-cell img" :src="form.brandLogoUrl" alt="" />
            <div class="preview-cell title">{{ form.headline || '此处为标题' }}</div>
            <div class="preview-cell now">Shop Now <i class="el-icon-arrow-right"></i></div>
            <div class="preview-cell sponsored">Sponsored</div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="preview preview2">
          <div class="preview-content content1">
            <img class="preview-cell img" :src="form.brandLogoUrl" alt="" />
            <div class="preview-cell title">{{ form.headline || '此处为标题' }}</div>
            <div class="preview-cell now">Shop Now <i class="el-icon-arrow-right"></i></div>
          </div>
          <div class="preview-content content2"></div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="preview preview3">
          <div class="preview-content">
            <img class="preview-cell img" :src="form.brandLogoUrl" alt="" />
            <div style="flex: 1">
              <div class="preview-cell title">{{ form.headline || '此处为标题' }}</div>
              <div class="preview-cell now">Shop Now <i class="el-icon-arrow-right"></i></div>
            </div>
            <div class="preview-cell sponsored">Sponsored</div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item>
        <div class="preview preview4">
          <div class="preview-content">
            <img class="preview-cell img" :src="form.brandLogoUrl" alt="" />
            <div style="flex: 1">
              <div class="preview-cell title">{{ form.headline || '此处为标题' }}</div>
              <div class="preview-cell now">Shop Now <i class="el-icon-arrow-right"></i></div>
            </div>
            <div class="preview-cell sponsored">Sponsored</div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
    name: "ad-preview",
    inject: [ "getForms" ],
    data() {
      return {
        form: {},
        previewMsg: [
          "搜索结果上方：移动设备广告",
          "搜索脚注：移动设备",
          "搜索脚注：桌面设备",
          "搜索脚注：桌面电脑广告",
        ],
        activeIndex: 1
      }
    },
    methods: {
      // 手动切换
      carouselOpt(opt) {
        this.$refs.carousel[opt]()
      },
      change() {
        this.activeIndex = Number(this.$refs.carousel.activeIndex) + 1
      }
    },
    created() {
      let { creative } = this.getForms()
      this.form = creative
    },
}
</script>

<style scoped lang="scss">
@mixin preview-style($width, $height, $top, $left) {
  width: $width;
  height: $height;
  top: $top;
  left: $left;
}
.preview-title {
  padding: 0 16px;
  display: flex;
  align-items: center;
  height: 42px;
  line-height: 1;
  font-size: 12px;
  border: 1px solid #eee;
  .preview-msg {
    width: 200px;
    text-align: center;
    margin: 0 16px;
    padding: 7px 0;
    border: 1px solid #eee;
    border-radius: 3px;
    color: #969696;
    transform: scale(.95);
  }
  .tag {
    color: #969696;
    padding-left: 16px;
    transform: translateY(7px);
  }
  /deep/.el-button {
    width: 0;
    height: 25px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}
.preview {
  height: 100%;
  position: relative;
  background-size: 100%;
  .title {
    overflow: hidden;
    word-break:break-all;
    display: -webkit-box;//将元素设为盒子伸缩模型显示
    -webkit-box-orient: vertical;//伸缩方向设为垂直方向
    -webkit-line-clamp: 2;//超出3行隐藏，并显示省略号
  }
  .preview-content {
    position: absolute;
    background: #F6F6F8;
    font-size: 12px;
    .img {
      background: #fff;
    }
    .now {
      color: #1F6EEF;
      .el-icon-arrow-right {
        transform: translateY(2px);
      }
    }
    .sponsored {
      position: absolute;
      bottom: 5px;
      right: 9px;
      color: #969696;
      transform: scale(.83);
    }
  }
  &.preview1 {
    background-image: url("~@/assets/images/ad/preview1.png");
    .preview-content {
      width: 384px;
      height: 134px;
      top: 198px;
      left: 95px;
      .preview-cell {
        position: absolute;
        &.img {
          @include preview-style(90px, 90px, 24px, 16px);
          background: #fff;
        }
        &.title {
          @include preview-style(220px, auto, 24px, 120px);
        }
        &.now {
          @include preview-style(220px, 42px, 55px, 120px);
        }
      }
    }
  }
  &.preview2 {
    background-image: url("~@/assets/images/ad/preview2.png");
    .preview-content {
      &.content1 {
       @include preview-style(136px, 122px, 280px, 110px);
       padding: 15px 0 0 12px;
      .img {
        width: 52px;
        height: 52px;
      }
      .title {
        margin: 11px 0 8px
      }
      .now {}
      }
      &.content2 {
        @include preview-style(196px, 134px, 280px, 267px);
      }
    }
  }
  &.preview3 {
    background-image: url("~@/assets/images/ad/preview3.png");
    display: flex;
    align-items: center;
    justify-content: center;
    .preview-content {
      width: 282px;
      height: 105px;
      padding: 6px 10px;
      background: #fff;
      display: flex;
      align-items: center;
      .img {
        width: 102px;
        height: 102px;
        background: #FFFFFF;
      }
      .title {
        margin:0 0 8px 16px;
      }
      .now {
        padding:0 0 0 16px;
      }
    }
  }
  &.preview4 {
    background-image: url("~@/assets/images/ad/preview3.png");
    display: flex;
    align-items: center;
    justify-content: center;
    .preview-content {
      width: 512px;
      height: 70px;
      padding: 6px 10px;
      background: #fff;
      display: flex;
      align-items: center;
      .img {
        width: 68px;
        height: 68px;
        background: #FFFFFF;
      }
      .title {
        padding:0 0 8px 16px;
      }
      .now {
        padding:0 0 0 16px;
      }
    }
  }
}
</style>